<template>
  <MapContainer :fluid="false">
    <MapGetter
      v-slot="{ map, popup }"
      type="oecd"
      theme="light"
      :container="`${indicator}-sdg7-map-container`"
      :subregionBubble="false"
      :bubble="false"
      :zoom="1.2"
      :minZoom="1.2"
      :maxZoom="5.5"
    >
      <Map
        :map="map"
        :popup="popup"
        :year="year"
        :data="data"
        :indicator="indicator"
        :id="`${indicator}-sdg7-map-container`"
        @handle-minmax="handleMinMax"
        @handle-value="handleValue"
      />
    </MapGetter>
    <MapControls>
      <MapControl :bottom="true">
        <Slider
          v-model="year"
          :decimals="0"
          :min="minmaxyear[0]"
          :max="minmaxyear[1]"
          :step="1"
          title="Year"
          @input="changeYear"
        />
        <MapLegend :legend="legend" />
      </MapControl>
    </MapControls>
  </MapContainer>
</template>

<script>
import Map from "./components/Map.vue";
import axios from "axios";
import { Slider } from "@international-energy-agency/vue-ui";
import { colorScheme } from "./assets/util";
import {
  MapGetter,
  MapContainer,
  MapLegend,
  MapControls,
  MapControl,
} from "@international-energy-agency/vue-ui/maps";

export default {
  name: "App",
  components: {
    Map,
    Slider,
    MapGetter,
    MapContainer,
    MapLegend,
    MapControls,
    MapControl,
  },
  props: {
    indicator: {
      type: String,
      default: "Energy intensity measured in terms of primary energy and GDP",
    },
  },
  data() {
    return {
      data: null,
      mapValue: null,
      minmax: [],
      baseurl: "https://api.iea.org/sdg",
      year: colorScheme[this.indicator].minmax[1],
      indicators: [
        "Energy intensity measured in terms of primary energy and GDP",
        "Modern renewable share in total final energy consumption",
        "Share of population with access to clean cooking",
        "Share of population with access to electricity",
      ],
    };
  },
  created() {
    this.fetchData();
  },
  watch: {
    param() {
      this.fetchData();
    },
    minmaxyear(minmaxyear) {
      this.year = minmaxyear[1];
    },
  },
  computed: {
    minmaxyear() {
      return colorScheme[this.indicator].minmax;
    },
    legend() {
      let max = !this.minmax[1] ? 0 : this.minmax[1].toFixed();
      return [
        {
          type: "continuous",
          title: colorScheme[this.indicator].legend,

          colors: colorScheme[this.indicator].color,
          labels: [0, max],
          value: this.mapValue,
        },
      ];
    },
    param() {
      return {
        year: this.year,
        flow: this.indicator,
      };
    },
  },
  methods: {
    fetchData() {
      axios
        .get(this.baseurl, { params: this.param })
        .then((response) => {
          let data = response.data;
          this.data = data.filter((d) => d.ISO3 && d.ISO3 !== "TWN" && d.value);
        })
        .catch((error) => console.log("error fetching data:", error));
    },
    handleValue(value) {
      this.mapValue = value;
    },
    changeYear(year) {
      this.year = year;
    },
    handleMinMax(value) {
      this.minmax = value;
    },
  },
};
</script>

<style></style>
